module.exports = __webpack_public_path__ + "static/img/index.rotating-balls-spinner.107841f5.svg";